// extracted by mini-css-extract-plugin
export default {"ViewSwitcher":"ViewSwitcher_ViewSwitcher__Cg7Z8","ViewSwitcher__Btn":"ViewSwitcher_ViewSwitcher__Btn__qcRGy"};